import {
    changeFieldProperty,
    setFieldEdition,
    setFieldListOptions,
    setFieldStartDate,
    setFieldVisibility,
    setSectionTKey
} from "../../../../../apps/KpModule/actions";
import _ from "lodash";
import moment from "moment";
import {getDataListList} from "../../../../../apps/KpModule/selectors";
import {getFieldsByPath} from "../utils";
import {generateFetchFieldListAction, GET_OBJECT_SUCCESS} from "../../../../../apps/KpModule/actions/api";
import {ObjectId} from "bson";

export const module_ = {
    object: 'LiberalityRecord',
    name: 'LiberalityRecord',
    tKey: 'Dossier',
    objectIdentifier: 'applicationNumber',
    category: {
        path: 'menuTitle_liberalities',
        icon: 'testament'
    },
    formSections: [
        {
            id: 'benefactor',
            tKey: "Bienfaiteur(rice)",
            defaultCollapsed: false,
            //color: "rgb(252, 185, 0)"
        },
        {
            id: 'communDocuments',
            tKey: "Pièces communes aux biens",
            //Pièces communes et spécifiques du bien
            defaultCollapsed: true,
            //color: "rgb(252, 185, 0)"
        },
        {
            id: 'conversationHistory',
            tKey: "Historique d'échanges",
            defaultCollapsed: true,
            //color: "rgb(252, 185, 0)"
        },
        {
            id: 'receivables',
            tKey: "Dettes",
            defaultCollapsed: true,
            //color: "rgb(252, 185, 0)"
        }
    ],
    viewMap: {
        dt: [
            {path: 'presentationDate', tKey: 'Présentation', initiallyNotVisible: true},
            {path: 'applicationNumber', tKey: 'N° dossier', initiallyNotVisible: true},
            {path: 'benefactor'},
            {path: 'administrator', display: 'fullName', tKey: 'Gestionnaire', initiallyNotVisible: true},
            {path: 'typeOfFile', display: 'code', tKey: 'Nature', initiallyNotVisible: true},
            {path: 'qualificationsDisplay', tKey: 'Qualification(s)', initiallyNotVisible: true,},
            {path: 'beneficiaries', tKey: 'Bénéficiaire(s)'},
            {path: 'netForecast', tKey: 'Net prévu (€)', tooltip: true},
            {path: 'netAchievedTotal', tKey: 'Net réalisé (€)', tooltip: true},
            {path: 'receivedTotal', tKey: 'Reçu (€)', tooltip: true},
            {path: 'reversedAndAdvanceRecoveryTotal', tKey: 'Reversé (€)', tooltip: true},
            {path: 'advanceRecoveryTotal', tKey: "Reprise d'avance (€)", tooltip: true, initiallyNotVisible: true},
            {path: 'reversedTotal', tKey: 'Versement (€)', tooltip: true, initiallyNotVisible: true},
            {path: 'CNDAShare', tKey: 'Dont part CNDA prévu (€)', tooltip: true, initiallyNotVisible: true},
            {path: 'CNDAShareTotal', tKey: 'Part CNDA reçu (€)', tooltip: true, initiallyNotVisible: true},
            {path: 'status', tKey: 'Statut', type: 'status', fieldPath: ['id', 'name', 'bStyle']},
            {path: 'decisionDate', tKey: 'Date décision', initiallyNotVisible: true},
            {path: 'updatedBy', tKey: 'MAJ par', initiallyNotVisible: true},
            {path: 'updatedAt', tKey: 'MAJ le', initiallyNotVisible: true},
            {path: 'noDeleteButtonAccess', hidden: true},
        ],
        form: {
            fields: [
                {path: 'applicationNumber', tKey: 'N° dossier', disabled: true, widthClassName: "col-xs-12 col-sm-6"},
                {path: 'administrator', display: 'fullName', tKey: 'Gestionnaire', filters: ['eligibleToLiberalityProcess'], widthClassName: "col-xs-12 col-sm-6"},
                {
                    path: 'typeOfFile',
                    editable: false,
                    sortList: false,
                    widthClassName: "col-xs-12 col-sm-6",
                    display: 'fullName',
                    subscriptions: {
                        onChange: (newValue, oldValue, { module, store, formInitialize, getObjectSuccessAction }) => {
                            const state = store.getState()

                            const assetsInfosField = module.viewMap.form.fields.find(field => field.path === 'assetsInfos')
                            const repartitionField = assetsInfosField.viewMap.form.fields.find(field => field.path === 'distribution')

                            if(newValue) {
                                const isLegs = newValue.id === 'legs'
                                const isLifeInsurance = newValue.id === 'lifeInsurance'
                                const isDonationOrGiftsOnInheritance = ['donations', 'giftsOnInheritance'].includes(newValue.id)

                                const actFeesField = module.viewMap.form.fields.find(field => field.path === 'actsFees')
                                const actFeesDetailsField = module.viewMap.form.fields.find(field => field.path === 'actsFeesDetails')

                                store.dispatch(setFieldVisibility(actFeesField.id, !isLifeInsurance))
                                store.dispatch(setFieldVisibility(actFeesDetailsField.id, !isLifeInsurance))

                                if(isLifeInsurance) {
                                    actFeesField.setValue(0)
                                    actFeesDetailsField.setValue('')
                                }

                                const assetsInfosFieldFormField = assetsInfosField.viewMap.form.fields.find(field => field.path === 'assetLiabilities')
                                const ownLiabilitiesFormField = repartitionField.viewMap.form.fields.find(field => field.path === 'beneficiaryOwnLiabilities')

                                const qualificationListField = repartitionField.viewMap.dt.fields.find(field => field.path === 'qualification')
                                const qualificationFormField = repartitionField.viewMap.form.fields.find(field => field.path === 'qualification')

                                const typeOfPropertyListField = assetsInfosField.viewMap.dt.fields.find(field => field.path === 'typeOfProperty')
                                const typeOfPropertyFormField = assetsInfosField.viewMap.form.fields.find(field => field.path === 'typeOfProperty')

                                // Passif propre: visible for LG (not AV, DO, DS)
                                store.dispatch(setFieldVisibility(ownLiabilitiesFormField.id, isLegs))
                                store.dispatch(setFieldVisibility(assetsInfosFieldFormField.id, isLegs))

                                // QF: visible only for LG
                                store.dispatch(setFieldVisibility(qualificationListField.id, isLegs))
                                store.dispatch(setFieldVisibility(qualificationFormField.id, isLegs))

                                const qualificationsDisplayField = module.viewMap.form.fields.find(field => field.path === 'qualificationsDisplay')
                                store.dispatch(setFieldVisibility(qualificationsDisplayField.id, isLegs))

                                // Natures du bien / Catégorie: visible for LG, DO, DS (not AV)
                                store.dispatch(setFieldVisibility(typeOfPropertyListField.id, !isLifeInsurance))
                                store.dispatch(setFieldVisibility(typeOfPropertyFormField.id, !isLifeInsurance))

                                const typeOfPropertyDisplay = isLegs ? 'category' : 'natureOfProperty'

                                store.dispatch(changeFieldProperty(typeOfPropertyListField.id, 'tKey', typeOfPropertyDisplay))
                                store.dispatch(changeFieldProperty(typeOfPropertyFormField.id, 'tKey', typeOfPropertyDisplay))

                                const options = getDataListList(state, 'm-C-liberalityRecord.AssetInfos_typeOfProperty')
                                const filteredOptions = options.filter(option => {
                                    return isLegs
                                        ? option.category
                                        : isDonationOrGiftsOnInheritance
                                            ? option.natureOfProperty
                                            : false
                                })

                                store.dispatch(setFieldListOptions(typeOfPropertyFormField.id, _.map(filteredOptions, "id")))
                            }
                            const objectMode = state.ui.objectMode
                            const changedValue = objectMode === 'newObject' && oldValue?.id !== newValue?.id
                            if (changedValue) assetsInfosField.setValue([])

                            if (objectMode === 'newObject') {
                                store.dispatch(
                                    generateFetchFieldListAction(
                                        "m-C-liberalityRecord.FileList_fileCategory",
                                        store.getState,
                                        { data: { fileNature : newValue } }
                                    )
                                ).then((response) => {
                                    const fileCategories = response.data || []
                                    const fileListField = module.viewMap.form.fields.find(field => field.path === 'filesList')
                                    const necessaryCategories = fileCategories.filter(category => {
                                        const valueForThisType = category.fileConfigurations.find(config => config.typeOfLiberalityRecord.id === newValue?.id)
                                        return valueForThisType?.fileStatus.id === 'necessary'
                                    })
                                    fileListField.setValue(necessaryCategories.map(fileCategory => {
                                        return {
                                            id: new ObjectId(),
                                            fileCategory: {
                                                id: fileCategory.id,
                                                title: fileCategory.title,
                                            },
                                            files: [],
                                            noDeleteButtonAccess: true,
                                            filesNumber: 0
                                        }
                                    }))
                                })
                            }
                        }
                    }
                },
                {
                    path: 'qualificationsDisplay',
                    tKey: 'Qualification(s)',
                    disabled: true,
                    widthClassName: "col-xs-12 col-sm-6",
                },

                {path: 'benefactorFirstName', section: 'benefactor', tKey: 'Prénom', required: true, widthClassName: "col-xs-12 col-sm-6"},
                {path: 'benefactorBirthName', section: 'benefactor', tKey: 'Nom de naissance', required: true, widthClassName: "col-xs-12 col-sm-6"},
                {path: 'benefactorMaritalStatus', section: 'benefactor', sortList: false, tKey: 'État matrimonial', widthClassName: "col-xs-12 col-sm-6"},
                {path: 'benefactorMaritalName', section: 'benefactor', tKey: 'Nom marital', widthClassName: "col-xs-12 col-sm-6"},
                {path: 'benefactorBirthDate', section: 'benefactor', tKey: 'Date de naissance', widthClassName: "col-xs-12 col-sm-6"},
                {path: 'benefactorBirthPlace', section: 'benefactor', tKey: 'Lieu de naissance', widthClassName: "col-xs-12 col-sm-6"},
                {path: 'benefactorDeathDate', section: 'benefactor', tKey: 'Date de décès', widthClassName: "col-xs-12 col-sm-6"},
                {path: 'benefactorDeathPlace', section: 'benefactor', tKey: 'Lieu de décès', widthClassName: "col-xs-12 col-sm-6"},
                {path: 'benefactorMainResidence', section: 'benefactor', tKey: 'Résidence principale', widthClassName: "col-xs-12 col-sm-6"},
                {path: 'benefactorReservatoryHeirs', section: 'benefactor', tKey: 'Héritier/ère(s) réservataire(s)', widthClassName: "col-xs-12 col-sm-6"},

                {
                    path: 'beneficiariesDisplay',
                    tKey: 'Bénéficiaire(s)',
                    disabled: true
                },
                {path: 'netForecast', tKey: 'Net prévu (€)', type: 'number', widthClassName: "col-xs-12 col-sm-6", disabled: true},
                {path: 'CNDAShare', tKey: 'Dont part CNDA prévue (€)', widthClassName: "col-xs-12 col-sm-6", disabled: true},
                {path: 'comment', type: "richTextEditor"},
                {
                    path: 'stakeholders',
                    tKey: 'Partie(s) prenante(s)',
                    viewMap: {
                        dt: [
                            {path: 'stakeholder.organization.organizationType.name', display: 'name', tKey: 'Type organisation'},
                            {path: 'stakeholder.organization.tradingName', tKey: "Nom d'usage de l'organisation"},
                            {path: 'stakeholder.fullName', tKey: 'Prénom Nom du contact'},
                            {path: 'stakeholder.mail', tKey: 'Courriel'},
                            {path: 'stakeholder.phone', tKey: 'Téléphone'},
                        ],
                        form: [
                            {
                                path: 'stakeholder',
                                tKey: 'Partie prenante',
                                display: 'completeInfo',
                                fieldPath: ['id', 'completeInfo', 'fullName', 'organization.organizationType.name', 'organization.tradingName', 'mail', 'phone'],
                                required: true,
                                filters: ['fromSupplierOrganization']
                            },
                        ]
                    }
                },
                {
                    path: 'assetsInfos',
                    tKey: 'Biens',
                    required: true,
                    viewMap: {
                        dt: [
                            {path: 'typeOfProperty', tKey: 'category'},
                            'identifier',
                            'estimatedAssetValue',
                            'assetLiabilities',
                            {path: 'estimatedAssetNetValue'},
                            'beneficiariesShareInAssetEstimatedValue',
                            'beneficiariesShareInAssetLiabilities',
                            'beneficiariesOwnLiabilities',
                            'beneficiariesShareInLiberalityRecordActsFees',
                            'estimatedBeneficiariesNetValue',
                            'CNDAShareInEstimatedBeneficiariesNetValue'
                        ],
                        form: [
                            {path: 'typeOfProperty', fieldPath: ['id', 'name', 'category', 'natureOfProperty'], tKey: 'category', required: true, widthClassName: "col-xs-12 col-sm-6",},
                            {path: 'identifier', required: true, widthClassName: "col-xs-12 col-sm-6",},
                            {path: 'comment', type: "richTextEditor", },
                            {
                                path: 'estimatedAssetValue',
                                widthClassName: "col-xs-12 col-sm-6",
                                minValue: 0,
                                default: 0,
                                required: true
                            },
                            {
                                path: 'assetLiabilities',
                                widthClassName: "col-xs-12 col-sm-6",
                                minValue: 0,
                                default: 0,
                                required: true
                            },
                            {
                                path: 'distribution',
                                tKey: 'Répartitions des biens',
                                viewMap: {
                                    dt: [
                                        {path: 'confFor', tKey: 'Pour'},
                                        {path: 'beneficiary', display: 'zipCodeAndName'},
                                        {path: 'qualification', tKey: 'Qualification'},
                                        {path: 'share', tKey: 'Quote-part'},
                                        {path: 'beneficiaryShareInAssetEstimatedValue', initiallyNotVisible: true},
                                        {path: 'beneficiaryShareInAssetLiabilities', initiallyNotVisible: true},
                                        {path: 'beneficiaryOwnLiabilities', initiallyNotVisible: true},
                                        {path: 'actsFeesSupported', initiallyNotVisible: true},
                                        {path: 'beneficiaryShareInLiberalityRecordActsFees', initiallyNotVisible: true},
                                        {path: 'estimatedBeneficiaryNetValue', initiallyNotVisible: true},
                                        {path: 'CNDAShareInEstimatedBeneficiaryNetValue', initiallyNotVisible: true},
                                    ],
                                    form: [
                                        {path: 'confFor', tKey: 'CONF. DEFENSE DE L’ANIMAL POUR'},
                                        {path: 'beneficiary', display: 'zipCodeAndName', filters: ['isAssociation'], widthClassName: "col-xs-12 col-sm-6"},
                                        {path: 'qualification', required: true, widthClassName: "col-xs-12 col-sm-6"},
                                        {
                                            path: 'share',
                                            tKey: 'Quote-part',
                                            required: true,
                                            default: 0,
                                            minValue: 0,
                                            maxValue: 100,
                                            widthClassName: "col-xs-12 col-sm-6",
                                            subscriptions: {
                                                onChange: (newValue, oldValue, { module, store }) => {
                                                    const forms = store.getState().form
                                                    const editedRow = _.get(forms, 'distributionEditObject.values')
                                                    const rows = _.get(forms, 'assetsInfosEditObject.values.distribution') || []
                                                    const otherShares = _.sumBy(
                                                        rows.filter(row => !editedRow?.id || row.id !== editedRow.id),
                                                        row => Number(row.share) || 0
                                                    )
                                                    const maxShare = Math.max(0, 100 - otherShares)

                                                    const assetsInfosField = module.viewMap.form.fields.find(f => f.path === 'assetsInfos')
                                                    const distField = assetsInfosField.viewMap.form.fields.find(f => f.path === 'distribution')
                                                    const shareField = distField.viewMap.form.fields.find(f => f.path === 'share')
                                                    store.dispatch(changeFieldProperty(shareField.id, 'maxValue', maxShare))
                                                }
                                            }
                                        },

                                        /*{
                                            path: 'beneficiaryShareInAssetEstimatedValue',
                                            disabled: true,
                                            default: 0
                                        },
                                        {
                                            path: 'beneficiaryShareInAssetLiabilities',
                                            disabled: true,
                                            default: 0
                                        },
                                        {
                                            path: 'beneficiaryShareInLiberalityRecordActsFees',
                                            disabled: true,
                                            default: 0
                                        },*/

                                        {
                                            path: 'beneficiaryOwnLiabilities',
                                            required: true,
                                            default: 0,
                                            widthClassName: "col-xs-12 col-sm-6",
                                            /*subscriptions: {
                                                onChange: (newValue, oldValue, { module }) => {
                                                    const assetsInfosField = module.viewMap.form.fields.find(f => f.path === 'assetsInfos')
                                                    const f = getFieldsByPath(assetsInfosField.viewMap.form.fields, ['estimatedAssetNetValue'])
                                                    const distField = assetsInfosField.viewMap.form.fields.find(f => f.path === 'distribution')
                                                    const g = getFieldsByPath(distField.viewMap.form.fields, ['share', 'estimatedBeneficiaryNetValue'])
                                                    const estimatedBeneficiaryNetValue = ((f.estimatedAssetNetValue.getValue() ?? 0) * (g.share.getValue() ?? 0) / 100) - (newValue ?? 0)
                                                    g.estimatedBeneficiaryNetValue.setValue(estimatedBeneficiaryNetValue)
                                                }
                                            }*/
                                        },
                                        {path: 'actsFeesSupported', widthClassName: "col-xs-12 col-sm-6"},
                                        /*{
                                            path: 'estimatedBeneficiaryNetValue',
                                            default: 0,
                                            required: true,
                                            widthClassName: "col-xs-12 col-sm-6",
                                            disabled: true,
                                            subscriptions: {
                                                onChange: (newValue, oldValue, { module }) => {
                                                    const assetsInfosField = module.viewMap.form.fields.find(f => f.path === 'assetsInfos')
                                                    const distField = assetsInfosField.viewMap.form.fields.find(f => f.path === 'distribution')
                                                    const f = getFieldsByPath(distField.viewMap.form.fields, ['CNDAShareInEstimatedBeneficiaryNetValue'])
                                                    const CNDAShare = (newValue ?? 0) * 6 / 100
                                                    f.CNDAShareInEstimatedBeneficiaryNetValue.setValue(CNDAShare)
                                                }
                                            }
                                        },
                                        {
                                            path: 'CNDAShareInEstimatedBeneficiaryNetValue',
                                            disabled: true,
                                            default: 0
                                        }*/
                                    ],
                                },
                                validations: [
                                    function() {
                                        return function validation(value) {
                                            const totalShare = _.sumBy(value || [], o => Number(o.share) || 0)
                                            return totalShare > 100 ? 'sharesTotalMustNotExceed100' : undefined
                                        }
                                    }
                                ],
                            },
                            {path: 'status', hidden: true}
                        ],
                    },
                    subscriptions: {
                        onChange: (newValue, oldValue, { module, store, formInitialize, getObjectSuccessAction }) => {
                            const distributions = (newValue || []).flatMap(item => item.distribution || [])

                            const qualificationsDisplayField = module.viewMap.form.fields.find(f => f.path === 'qualificationsDisplay')
                            const distinctQualifications = [...new Set(distributions.map(part => part.qualification?.name).filter(Boolean))].join(', ')
                            if (qualificationsDisplayField) qualificationsDisplayField.setValue(distinctQualifications)

                            const beneficiariesDisplayField = module.viewMap.form.fields.find(f => f.path === 'beneficiariesDisplay')
                            const distinctBeneficiaries = [...new Set(distributions.map(part => part.beneficiary?.zipCodeAndName).filter(Boolean))].join(', ')
                            if (beneficiariesDisplayField) beneficiariesDisplayField.setValue(distinctBeneficiaries)

                            const imputationTemplate = (newValue || []).flatMap(asset =>
                                (asset.distribution || []).map(dist => ({
                                    id: new ObjectId(),
                                    asset: { id: asset.id, identifier: asset.identifier },
                                    beneficiary: dist.beneficiary,
                                    beneficiaryShare: dist.share,
                                    imputedAmount: 0
                                }))
                            )

                            const receivablesField = module.viewMap.form.fields.find(f => f.path === 'receivables')
                            const imputationsField = receivablesField.viewMap.form.fields.find(f => f.path === 'imputations')
                            store.dispatch(changeFieldProperty(imputationsField.id, 'default', imputationTemplate))
                            if (!formInitialize) receivablesField.setValue([])
                        }
                    }
                },
                {
                    path: 'actsFees',
                    tKey: 'Frais d’actes (€)',
                    minValue: 0,
                    default: 0,
                    required: true,
                    /*subscriptions: {
                        onChange: (newValue, oldValue, { module, store, formInitialize, getObjectSuccessAction }) => {
                            const neededFields = getFieldsByPath(module.viewMap.form.fields, ['netForecast']);
                            neededFields.netForecast.setValue(newNetForecast)
                        }
                    }*/
                },
                {path: 'actsFeesDetails', tKey: 'Détails liés aux frais d’actes', type: "richTextEditor"},

                {
                    path: 'filesList',
                    tKey: 'Pièces',
                    section: 'communDocuments',
                    removable: true,
                    viewMap: {
                        dt: [
                            {path: 'fileCategory', tKey: 'title', display: 'title'},
                            {path: 'filesNumber'},
                            {path: 'noDeleteButtonAccess', hidden: true},
                        ],
                        form: [
                            {
                                path: 'fileCategory',
                                editable: false,
                                tKey: 'title',
                                display: 'title',
                                fieldPath: ['id', 'title', 'fileConfigurations'],
                                filters: ['getNecessaryOrUsefulByFileNatureAndExcludeAlreadyUsedForLiberalityRecord'],
                                warnIfNotFound: false
                            },
                            {
                                path: 'files',
                                type: 'simpleFiles',
                                fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'],
                                subscriptions: {
                                    onChange: (newValue, oldValue, { module, store, formInitialize, getObjectSuccessAction }) => {
                                        const fileListField = module.viewMap.form.fields.find(field => field.path === 'filesList')
                                        const filesNumberField = fileListField.viewMap.form.fields.find(field => field.path === 'filesNumber')
                                        filesNumberField.setValue(newValue?.length || 0)
                                    }
                                }
                            },
                            {path: 'noDeleteButtonAccess', hidden: true, default: false},
                            {path: 'filesNumber', hidden: true, default: 0},
                        ]
                    },
                    subscriptions: {
                        onChange: (newValue, oldValue, { module, store, formInitialize, getObjectSuccessAction }) => {
                            if(newValue) {
                                const typeOfFileField = module.viewMap.form.fields.find(field => field.path === 'typeOfFile')
                                const typeOfFile = typeOfFileField.getValue()

                                store.dispatch(
                                    generateFetchFieldListAction(
                                        "m-C-liberalityRecord.FileList_fileCategory",
                                        store.getState,
                                        {
                                            data: {
                                                fileNature : typeOfFile,
                                                alreadyUsedIds : newValue.map(file => file.fileCategory.id),
                                            }
                                        }
                                    )
                                )
                            }
                        }
                    }
                },

                {
                    path: 'receivables',
                    tKey: 'Dettes',
                    section: 'receivables',
                    viewMap: {
                        dt: [
                            {path: 'pieceNumber', tKey: 'N° pièce'},
                            {path: 'pieceDate', tKey: 'Date pièce', initiallyNotVisible: true},
                            {path: 'creditor', tKey: 'Créancier', display: 'name'},
                            {path: 'expenseCategory', tKey: 'Catégorie', display: 'name', initiallyNotVisible: true},
                            {path: 'totalAmount', tKey: 'Total (€)'},
                            {path: 'dueDate', tKey: "Date d'échéance", initiallyNotVisible: true},
                            {path: 'status', tKey: 'Statut', display: 'name'},
                            {path: 'settlementDate', tKey: 'Date règlement', initiallyNotVisible: true},
                        ],
                        form: [
                            {path: 'pieceNumber', tKey: 'N° pièce', required: true, widthClassName: 'col-xs-12 col-sm-6', editable: false},
                            {
                                path: 'pieceDate',
                                tKey: 'Date pièce',
                                required: true,
                                editable: false,
                                endDate: moment().format('YYYY-MM-DD'),
                                widthClassName: 'col-xs-12 col-sm-6',
                                subscriptions: {
                                    onChange: (newValue, oldValue, { module, store }) => {
                                        const receivablesField = module.viewMap.form.fields.find(f => f.path === 'receivables')
                                        const dueDateField = receivablesField.viewMap.form.fields.find(f => f.path === 'dueDate')
                                        store.dispatch(setFieldStartDate(dueDateField.id, newValue || moment().format('YYYY-MM-DD')))
                                    }
                                }
                            },
                            {
                                path: 'creditor',
                                tKey: 'Créancier',
                                display: 'name',
                                required: true,
                                editable: false,
                                filters: ['isSupplier'],
                                widthClassName: 'col-xs-12 col-sm-6'
                            },
                            {
                                path: 'expenseCategory',
                                tKey: 'Catégorie',
                                display: 'name',
                                required: true,
                                editable: false,
                                filters: ['active'],
                                widthClassName: 'col-xs-12 col-sm-6'
                            },
                            {path: 'totalAmount', tKey: 'Total (€)', required: true, widthClassName: 'col-xs-12 col-sm-6', editable: false},
                            {path: 'dueDate', tKey: "Date d'échéance", widthClassName: 'col-xs-12 col-sm-6', editable: false},
                            {
                                path: 'imputations',
                                tKey: 'Imputation(s)',
                                editable: true,
                                viewMap: {
                                    dt: [
                                        {path: 'asset', tKey: 'Bien', display: 'identifier'},
                                        {path: 'beneficiary', tKey: 'Bénéficiaire', display: 'zipCodeAndName'},
                                        {path: 'beneficiaryShare', tKey: 'Quote-part (%)', numberOfDecimals: 2},
                                        {path: 'imputedAmount', tKey: 'Imputé (€)', type: 'editNumber', editable: true},
                                    ]
                                },
                                validations: [
                                    function() {
                                        return function validation(value, values) {
                                            const totalAmount = values.totalAmount
                                            const imputedTotal = _.sumBy(value || [], o => Number(o.imputedAmount) || 0)
                                            return Math.abs((totalAmount || 0) - imputedTotal) > 0 ? 'imputedAmountsMustEqualTotalAmount' : undefined
                                        }
                                    }
                                ]
                            },
                            {
                                path: 'status',
                                tKey: 'Statut',
                                display: 'name',
                                sortList: false,
                                widthClassName: 'col-xs-12 col-sm-6',
                                subscriptions: {
                                    onChange: (newValue, oldValue, { module, store, formInitialize }) => {
                                        const receivablesField = module.viewMap.form.fields.find(f => f.path === 'receivables')
                                        const statusField = receivablesField.viewMap.form.fields.find(f => f.path === 'status')
                                        const settlementDateField = receivablesField.viewMap.form.fields.find(f => f.path === 'settlementDate')

                                        if (!formInitialize) {
                                            settlementDateField.setValue(null)
                                        }

                                        const isSettled = newValue?.id === 'settled'
                                        store.dispatch(setFieldVisibility(settlementDateField.id, isSettled))
                                        store.dispatch(changeFieldProperty(settlementDateField.id, 'required', isSettled))

                                        if (formInitialize) {
                                            store.dispatch(changeFieldProperty(statusField.id, 'editable', !isSettled))
                                            store.dispatch(changeFieldProperty(settlementDateField.id, 'editable', !isSettled))
                                        }
                                    }
                                }
                            },
                            {
                                path: 'settlementDate',
                                tKey: 'Date de règlement',
                                endDate: moment().format('YYYY-MM-DD'),
                                widthClassName: 'col-xs-12 col-sm-6'
                            },
                            {path: 'comment', tKey: 'Commentaire', type: 'richTextEditor', editable: false},
                            {path: 'files', tKey: 'Pièces', type: 'simpleFiles'}
                        ]
                    }
                },

                {path: 'conversations', tKey: "interactionZone", section: 'conversationHistory',},

                {path: 'status', hidden: true},
                {path: 'buttons', hidden: true}

            ],
            onOpen: ({ store, module, newValue }) => {
                const state = store.getState()
                const id = _.get(state, 'edit.object.id')
                const statusId = _.get(state, 'edit.object.data.status.id')
                const partiesSectionFields = module.viewMap.form.fields.filter(field => ['administrator'].includes(field.path))
                const actsFeesSectionFields = module.viewMap.form.fields.filter(field => field.path === 'actsFees')
                const assetsSectionFields = module.viewMap.form.fields.filter(field => field.path === 'assetsInfos')
                const notLockedSectionFields = module.viewMap.form.fields.filter(field => ['comment', 'stakeholders', 'actsFeesDetails', 'filesList', 'receivables', 'conversations'].includes(field.path))
                const lifeInsuranceSectionFields = module.viewMap.form.fields.filter(field => field.section === "lifeInsuranceSection")
                const benefactorSectionFields = module.viewMap.form.fields.filter(field => field.section === 'benefactor')

                // Bienfaiteur(rice) : modifiable à la création, puis uniquement en Brouillon, Ajournement ou Révision
                benefactorSectionFields.forEach(field => store.dispatch(setFieldEdition(field.id, ['draft', 'incomplete', 'revision'].includes(statusId))))
                partiesSectionFields.forEach(field => store.dispatch(setFieldEdition(field.id, !['abandoned', 'rejected', 'closed'].includes(statusId)))) //we excluded typeOfFile
                // Commentaire, Partie(s) prenante(s), Détails frais d'actes, Pièces communes, Dettes, Historique d'échanges : modifiables sauf Abandon, Renonciation, Clos
                notLockedSectionFields.forEach(field => store.dispatch(setFieldEdition(field.id, !['abandoned', 'rejected', 'closed'].includes(statusId))))
                // Bien(s) : modifiable uniquement en Brouillon, Ajournement ou Révision
                assetsSectionFields.forEach(field => store.dispatch(setFieldEdition(field.id, ['draft', 'incomplete', 'revision'].includes(statusId))))
                // Frais d'actes : modifiable sauf À présenter, À représenter, Décision attendue, Abandon, Renonciation, Clos
                actsFeesSectionFields.forEach(field => store.dispatch(setFieldEdition(field.id, ['draft', 'incomplete', 'validated', 'revision', 'reopened'].includes(statusId))))
                lifeInsuranceSectionFields.forEach(field => store.dispatch(setFieldEdition(field.id, ['draft', 'incomplete'].includes(statusId))))

                const objectMode = state.ui.objectMode
                const applicationNumberField = module.viewMap.form.fields.find(field => field.path === 'applicationNumber')
                store.dispatch(setFieldVisibility(applicationNumberField.id, objectMode !== 'newObject'))

                /*store.dispatch(
                    generateFetchFieldListAction(
                        "m-C-liberalityRecord.AssetPartition_assetInfos",
                        store.getState,
                        { data: { liberalityRecordId : id } }
                    )
                )*/
            }
        }
    },
    actionSubscriptions: [
        {
            actionType: GET_OBJECT_SUCCESS,
            subscription: ({ store, module }) => {
                const state = store.getState()
                const firstName = _.get(state, 'edit.object.data.benefactorFirstName', '')
                const birthName = _.get(state, 'edit.object.data.benefactorBirthName', '')
                const nameSuffix = [firstName, birthName].filter(Boolean).join(' ')
                store.dispatch(setSectionTKey('benefactor', nameSuffix ? `Bienfaiteur(rice) : ${nameSuffix}` : 'Bienfaiteur(rice)'))
            }
        }
    ],
    /*stateSubscriptions: [
        {
            statePaths: [
                'form.assetsInfosEditObject.values.estimatedAssetValue',
                'form.assetsInfosEditObject.values.assetLiabilities',
            ],
            subscription: (newValue, previousValue, { changedField, store, module }) => {
                const estimatedAssetValue = _.get(store.getState(), 'form.assetsInfosEditObject.values.estimatedAssetValue')
                const assetLiabilities = _.get(store.getState(), 'form.assetsInfosEditObject.values.assetLiabilities')

                const newNetForecast = (estimatedAssetValue ?? 0) - (assetLiabilities ?? 0)

                const assetsInfosField = module.viewMap.form.fields.find(f => f.path === 'assetsInfos')
                const estimatedAssetNetValueField = assetsInfosField.viewMap.form.fields.find(f => f.path === 'estimatedAssetNetValue')

                estimatedAssetNetValueField.setValue(newNetForecast)
            }
        },
        {
            statePaths: [
                'form.assetsInfosEditObject.values.estimatedAssetValue'
            ],
            subscription: (newValue, previousValue, { store, module }) => {
                const estimatedAssetValue = _.get(store.getState(), 'form.assetsInfosEditObject.values.estimatedAssetValue')

                const assetsInfosField = module.viewMap.form.fields.find(f => f.path === 'assetsInfos')
                const distributionField = assetsInfosField.viewMap.form.fields.find(f => f.path === 'distribution')
                const distribution = distributionField.getValue() ?? []
                const result = distribution.map(item => ({...item, beneficiaryShareInAssetEstimatedValue: (estimatedAssetValue ?? 0) * (item.share ?? 0) / 100}))

                distributionField.setValue(result)
            }
        }
        //'form.distributionEditObject.values.share',
    ],*/
    filters: ['byStatus']
}
